import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

export const FileTypeDocxIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.49444 13.8576C9.613 14.7454 14.7317 14.7155 19.8502 13.8576V6.7415C19.8502 6.66042 19.824 6.58159 19.7753 6.51678L16.4046 2.0224C16.3338 1.92811 16.2228 1.87256 16.105 1.87256H5.61804C5.32006 1.87256 5.03422 1.99094 4.82352 2.20164C4.61282 2.41242 4.49444 2.69818 4.49444 2.99615V11.6104C4.49444 12.1667 4.36401 12.6381 4.36401 13.014C4.36401 13.5335 4.49444 13.8576 4.49444 13.8576Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2.24719 12.8867V20.9737C2.24719 21.2716 2.36557 21.5575 2.57627 21.7682C2.78697 21.9789 3.07281 22.0973 3.37079 22.0973H20.5993C20.8973 22.0973 21.183 21.9789 21.3938 21.7682C21.6045 21.5575 21.7229 21.2716 21.7229 20.9737C21.7229 19.5385 21.7229 16.4164 21.7229 14.9812C21.7229 14.6832 21.6045 14.3974 21.3938 14.1867C21.183 13.976 20.8973 13.8576 20.5993 13.8576H3.74535C3.26751 13.8576 2.24719 12.8867 2.24719 12.8867Z"
      fill="#2D98DB"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3.37079 13.8577C3.02886 13.8577 2.77924 13.719 2.59551 13.5482C2.42265 13.3875 2.24719 13.1042 2.24719 12.7341C2.24719 12.4965 2.36557 12.1502 2.57627 11.9396C2.78697 11.7289 3.07281 11.6105 3.37079 11.6105H4.49438V13.8577C4.49438 13.8577 4.59065 13.8577 3.37079 13.8577Z"
      fill="#216896"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.1049 1.87256V5.61791C16.1049 5.91588 16.2232 6.20173 16.4339 6.41242C16.6446 6.62312 16.9304 6.7415 17.2285 6.7415H19.8501C19.8501 6.66042 19.8239 6.58159 19.7752 6.51678L16.4045 2.0224C16.3337 1.92811 16.2227 1.87256 16.1049 1.87256Z"
      fill="#AFBDC7"
      fillRule="evenodd"
    />
    <path
      d="M7.86511 6.74152H12.7341"
      stroke="#AFBDC7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="0.748764"
    />
    <path
      d="M7.86511 8.98871H16.4793"
      stroke="#AFBDC7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="0.748764"
    />
    <path
      d="M7.86511 11.2359H16.4793"
      stroke="#AFBDC7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="0.748764"
    />
    <path
      clipRule="evenodd"
      d="M7.45963 17.6029C7.45963 17.1063 7.26233 16.63 6.91114 16.2788C6.55995 15.9276 6.08363 15.7303 5.587 15.7303C4.91734 15.7303 4.27617 15.7303 4.27617 15.7303C4.06925 15.7303 3.90161 15.8979 3.90161 16.1048V19.8501C3.90161 20.057 4.06925 20.2247 4.27617 20.2247H5.587C6.08363 20.2247 6.55995 20.0274 6.91114 19.6762C7.26233 19.325 7.45963 18.8487 7.45963 18.352V17.6029ZM6.7106 17.6029V18.352C6.7106 18.65 6.59222 18.9358 6.38152 19.1466C6.17083 19.3573 5.88498 19.4756 5.587 19.4756H4.65065V16.4793H5.587C5.88498 16.4793 6.17083 16.5977 6.38152 16.8084C6.59222 17.0192 6.7106 17.3049 6.7106 17.6029Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M14.0972 15.7675H13.8831C12.8489 15.7675 12.0105 16.6059 12.0105 17.6401V18.3893C12.0105 19.4235 12.8489 20.2619 13.8831 20.2619H14.0972C14.7653 20.2619 15.372 19.8721 15.6498 19.2645C15.6885 19.1798 15.7211 19.1086 15.7211 19.1086L15.3813 19.3255C15.2333 18.7893 15.1052 18.7229 15.0445 18.8045L15.0398 18.7972L14.9685 18.953C14.8127 19.2941 14.4722 19.5129 14.0972 19.5129H13.8832C13.2626 19.5129 12.7595 19.0098 12.7595 18.3893V17.6401C12.7595 17.0197 13.2626 16.5166 13.8831 16.5166H14.0972C14.4722 16.5166 14.8127 16.7353 14.9685 17.0763L15.0398 17.2322L15.0408 17.2343L15.0438 17.2407L15.0486 17.2502L15.0506 17.2543L15.0521 17.2571C15.1674 17.4749 15.3813 17.4529 15.3813 17.4529L15.403 17.4456C15.4989 17.4112 15.8728 17.2527 15.7211 16.9208L15.6498 16.7649C15.372 16.1573 14.7653 15.7675 14.0972 15.7675Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M9.75358 15.7303C8.74504 15.7303 7.88086 16.7168 7.88086 17.9775C7.88086 19.2382 8.74504 20.2247 9.75358 20.2247C10.7621 20.2247 11.6262 19.2382 11.6262 17.9775C11.6262 16.7168 10.7621 15.7303 9.75358 15.7303ZM9.75358 16.4793C10.3992 16.4793 10.8772 17.1704 10.8772 17.9775C10.8772 18.7846 10.3992 19.4756 9.75358 19.4756C9.10792 19.4756 8.62998 18.7846 8.62998 17.9775C8.62998 17.1704 9.10792 16.4793 9.75358 16.4793Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.6986 20.0967L19.9759 16.3514C20.1119 16.1959 20.0961 15.959 19.9406 15.8229C19.785 15.6869 19.5483 15.7026 19.4121 15.8582L16.135 19.6035C15.9989 19.759 16.0146 19.9959 16.1702 20.132C16.3258 20.2681 16.5626 20.2523 16.6986 20.0967Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M19.9759 19.6035L16.6986 15.8582C16.5626 15.7026 16.3258 15.6869 16.1702 15.8229C16.0146 15.959 15.9989 16.1959 16.135 16.3514L19.4121 20.0967C19.5483 20.2523 19.785 20.2681 19.9406 20.132C20.0961 19.9959 20.1119 19.759 19.9759 19.6035Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
  </svg>
);

export default FileTypeDocxIcon;
